module.exports = __webpack_public_path__ + "static/media/glass-martini.74edc24a.svg";